import { themeConfig, themePreset } from '@/themeConfig'
import { saveThemeDataCookie, getThemeDataFromCookie } from "@/utils/cookies";
const state = {
  themeMode: getThemeDataFromCookie() ? JSON.parse(getThemeDataFromCookie()) :themeConfig,
  vuetifyPreset: themePreset,
}

const getters = {
  getThemeMode: state => state.themeMode,
  getVuetifyPreset: state => state.vuetifyPreset,
}

const actions = {
  changeThemeMode ({ commit }) {
    commit('toggleThemeMode')
  },
  changeThemeLayout ({ commit }, data) {
    commit('toggleThemeLayout', data)
    saveThemeDataCookie(JSON.stringify(state.themeMode));
  },
  changeThemeDarkMode ({ commit }, data) {
    commit('toggleThemeDarkMode', data)
    saveThemeDataCookie(JSON.stringify(state.themeMode));
  },
  changeThemeRtl ({ commit }) {
    commit('toggleThemeRtl')
    saveThemeDataCookie(JSON.stringify(state.themeMode));
  },
  changeVerticalSidebarDrawer ({ commit }) {
    commit('toggleVerticalSidebarDrawer')
    saveThemeDataCookie(JSON.stringify(state.themeMode));
  },
  changeVerticalSaasSidebarDrawer ({ commit }) {
    commit('toggleVerticalSaasSidebarDrawer')
    saveThemeDataCookie(JSON.stringify(state.themeMode));
  },
  changeVerticalSidebarDrawerColor ({ commit }, data) {
    commit('toggleVerticalSidebarDrawerColor', data)
    saveThemeDataCookie(JSON.stringify(state.themeMode));
  },
  changeAppBarColor ({ commit }, data) {
    commit('toggleAppBarColor', data)
    saveThemeDataCookie(JSON.stringify(state.themeMode));
  },
  changeCompactVerticalSidebarDrawer ({ commit }) {
    commit('toggleCompactVerticalSidebarDrawer')
    saveThemeDataCookie(JSON.stringify(state.themeMode));
  },
  changeVerticalSidebarMini ({ commit }) {
    commit('toggleVerticalSidebarMini')
    saveThemeDataCookie(JSON.stringify(state.themeMode));
  },

  changeThemeLoadingState({ commit }, payload) {
    commit('toggleThemeLoadingState', payload)
    saveThemeDataCookie(JSON.stringify(state.themeMode));
  },
}

const mutations = {
  toggleThemeDarkMode (state, data) {
    state.themeMode.isDark = data
    this.$vuetify.theme.dark = data
  },
  toggleThemeLayout (state, data) {
    state.themeMode.layout = data
  },
  toggleThemeRtl (state) {
    state.themeMode.rtl = !state.themeMode.rtl
  },
  toggleThemeLoadingState (state, payload) {
    state.themeMode.isLoading = payload
  },
  toggleVerticalSidebarDrawer (state) {
    state.themeMode.verticalSidebarDrawer = !state.themeMode
      .verticalSidebarDrawer
  },
  toggleVerticalSaasSidebarDrawer (state) {
    state.themeMode.verticalSaasSidebarDrawer = !state.themeMode
      .verticalSaasSidebarDrawer
  },
  toggleVerticalSidebarDrawerColor (state, data) {
    state.themeMode.verticalSidebarDrawerColor = data
  },
  toggleAppBarColor (state, data) {
    state.themeMode.appBarColor = data
  },
  toggleCompactVerticalSidebarDrawer (state) {
    state.themeMode.verticalCompactSidebarDrawer = !state.themeMode
      .verticalCompactSidebarDrawer
  },
  toggleVerticalSidebarMini (state) {
    state.themeMode.verticalSidebarMini = !state.themeMode.verticalSidebarMini
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
